import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  addTabAction,
  changeTabAction,
  deleteTabAction,
  setCurrentTabItemAction,
  setMenuFromApi,
  setPermissionsFromApi,
} from '../redux/states/limpieza'
import {TabLimpiezaModel} from '../models/limpieza.model'
export const useLimpieza = () => {
  const limpiezaState = useSelector((store: AppStore) => store.limpieza)
  const {tabs, currentTab} = limpiezaState
  const currentTabItem = tabs[currentTab] || null
  const dispatch = useDispatch()

  const changeTab = (index: number) => {
    dispatch(changeTabAction(index))
  }

  const changeCurrentTabItem = (tab: TabLimpiezaModel) => {
    dispatch(setCurrentTabItemAction(tab))
  }

  const addTab = (newTab: TabLimpiezaModel) => {
    dispatch(addTabAction(newTab))
    return limpiezaState.tabs.length
  }

  const deleteTab = (index: number) => {
    const updatedTabs = [...tabs]
    updatedTabs.splice(index, 1)
    dispatch(deleteTabAction(updatedTabs))
  }
  const setMenu = (menu: any[]) => {
    dispatch(setMenuFromApi(menu))
  }
  const setPermissions = (permissions: any[]) => {
    dispatch(setPermissionsFromApi(permissions))
  }
  const isAllowed = (action: string) => {
    return currentTabItem.opciones?.some((item) => item.opcion === action)
  }

  // const isAllowedMultiUser = () => {
  //   const multiUserOptions =
  //     limpiezaState.permissions.find((item) => item.vista === '#MULTIUSUARIO')?.opciones || []
  //   return multiUserOptions.some((item: any) => item.opcion === 'VER')
  // }

  const isAllowedMultiUser = limpiezaState.permissions
    ?.find((item) => item.vista === '#MULTIUSUARIO')
    ?.opciones?.some((option: any) => option.opcion === 'VER')

  return {
    panel: limpiezaState.showPanel,
    currentTabItem,
    tabs: limpiezaState.tabs,
    currentTab: limpiezaState.currentTab,
    menu: limpiezaState.menu,
    addTab,
    deleteTab,
    changeTab,
    changeCurrentTabItem,
    setMenu,
    isAllowed,
    isAllowedMultiUser,
    setPermissions,
  }
}
